import { getTenantFromUrl } from '@/api/axiosInstance'
import { currentRouteScope } from '@/lib/routeScope'

/**
 * Identity of the tenant whose data is currently on screen, for keying persisted caches.
 *
 * Derived from the URL for the same reason the tenant request header is: the URL is the single
 * source of truth for which tenant a page is showing. A cache keyed on anything else can drift out
 * of step with the requests that filled it.
 *
 * Project routes (`/orgs/$orgId/projects/$tenantId/...`) scope to the project. Org-level routes
 * have no project segment, so they scope to the org — distinct from any project inside it, since
 * org-level pages read the org's root tenant.
 */
export function getCacheScope(): string {
	const tenantId = getTenantFromUrl()
	if (tenantId) {
		return tenantId
	}

	const { orgId } = currentRouteScope()
	return orgId ? `org:${orgId}` : ''
}
